



import StorePreviewComponent from "@/components/admin/store/storePreviewComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StorePreviewPage",
  components: {
    StorePreviewComponent,
  },
})
export default class StorePreviewPage extends Vue {}
